import {createContext} from 'react'
import {createContextualCan} from './libs/react-ability'

export const AbilityContext = createContext();
export const Can = createContextualCan(AbilityContext.Consumer);